export default {
  navigationV1b: {
    container: {
      position: 'fixed',
      width: '100%',
      top: '0px',
      left: '0px',
      zIndex: '1000',
      boxSizing: 'border-box',
      // height: '75px',
      padding: '0.5rem',
      display: 'flex',
      transition: 'all ease-in-out 0.5s',
      alignItems: ['flex-start', '', '', ''],
      justifyContent: ['center', '', '', 'flex-end']
    },

    hamburger: {
      position: 'relative',
      display: ['flex', '', '', 'none'],
      zIndex: '2000',
      alignSelf: 'center',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: '35px',
      height: '25px',
      cursor: 'pointer',
      margin: '0 0.5rem 0 auto',
      div: {
        alignSelf: 'flex-end',
        transition: 'all ease-in-out 0.3s',
        height: '4px',
        width: '100%',
        borderRadius: '10px',
        backgroundColor: 'secondary'
      }
    },
    hamburgerOpen: {
      position: 'relative',
      display: 'flex',
      zIndex: '2000',
      alignSelf: 'center',
      flexDirection: 'column',
      justifyContent: 'center',
      width: '35px',
      height: '25px',
      cursor: 'pointer',
      margin: '0 0.5rem 0 auto',
      div: {
        position: 'absolute',
        transition: 'all ease-in-out 0.3s',
        height: '4px',
        width: '100%',
        backgroundColor: 'text',
        borderRadius: '10px',
        boxShadow: 'none'
      },
      '& > :nth-child(1)': {
        transform: 'rotate(135deg) '
      },
      '& > :nth-child(2)': {
        transform: 'rotate(-135deg)'
      }
    },
    navLogo: {
      maxWidth: '200px',
      margin: '0.5rem 0rem 0rem 0rem',
      maxWidth: ['220px', '280px'],
      margin: ['1.5rem 0rem 0rem 0rem', '3rem 0rem 0rem 0rem']
    },

    logo: {
      position: ['relative', '', '', 'relative'],
      top: ['0.75rem', '', '', '0px'],
      left: ['-0.25rem', '', '', '0px'],
      alignSelf: 'center',
      zIndex: '2000',
      transition: 'all ease-in-out 0.3s',
      display: 'flex',
      flexDirection: 'column',
      img: {
        maxHeight: '90px'
      }
    },

    logoScrolled: {
      variant: 'navigationV1b.logo',
      display: ['', '', '', 'flex'],
      top: ['0rem', '', '', '0px'],
      left: ['-0.25rem', '', '', '0px'],
      img: {
        maxHeight: ['60px', '', '', '90px']
      }
    },

    menuLogo: {
      display: ['', '', '', 'none']
    },

    navMenu: {
      position: ['absolute', '', '', 'unset'],
      margin: '0px',
      boxSizing: 'border-box',
      justifyContent: ['center', '', '', 'flex-end'],
      height: ['100vh', '', '', 'unset'],
      backgroundColor: ['blue', '', '', 'unset'],
      top: '0px',
      zIndex: '2500',
      width: '50%',
      minWidth: '250px',
      left: -'120%',
      transition: 'all ease-in-out 0.5s',
      padding: ['5vh 5vw', '', '', '0rem 0rem 0rem 1rem'],
      alignItems: ['center', '', '', 'flex-start'],
      display: 'flex',
      flexDirection: ['column', '', '', 'row'],
      overflow: 'hidden',
      listStyleType: 'none',
      flexGrow: ['', '', '', '1'],
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundImage: [
        "url('https://media.gonation.com/w_800/q_auto/q_auto/sites/little-barn/background.jpg')",
        '',
        '',
        'unset'
      ],
      '.menuLogoContainer': {
        display: ['', '', '', 'none'],
        marginBottom: '2rem',
        marginBottom: ['0.5rem !important', '1rem', '2rem'],
        img: {
          maxWidth: '170px',
          width: '100%'
        }
      },
      '.navImage': {
        padding: ['', '', '', '', '0.2rem'],
        transition: 'all ease-in-out 0.3s',
        ':hover': {
          transform: 'rotate(5deg)'
        }
      }
    },
    navItem: {
      marginBottom: ['0.75rem', '', '', '0rem'],
      zIndex: '100',
      marginLeft: ['1rem', '', '', '1.5rem'],
      listStyleType: 'none',
      alignItems: 'center',
      margin: ['0px 0px 0.2rem', '', '', '0rem 0.5rem'],
      a: {
        fontSize: '1.25em',
        textTransform: 'uppercase',
        fontWeight: '400',
        color: 'light',
        letterSpacing: '2px',
        textDecoration: 'none'
      }
    },

    socialIconsContainer: {
      display: ['', '', '', 'none'],
      marginTop: ['2rem', '', '', '0rem'],
      svg: {
        width: '20px',
        height: '20px',
        marginRight: '0.5rem'
      }
    }
  }
}
